module.exports = __webpack_public_path__ + "img/video-post-thumb-dark.62a4e4dd.jpg";